import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './date-range-comparison.scss';
import { Moment } from 'moment';
import { FaHashtag, FaHryvnia } from 'react-icons/fa';
import api from 'api';
import CurrencyFormat from 'react-currency-format';
import React from 'react';

const DateRangeComparison = ({
    dateFrom,
    dateTo,
    streamIds,
    onClose,
    projectId
} : {
    projectId:number,
    dateFrom: Moment;
    dateTo: Moment,
    streamIds: number[];
    onClose: () => void
}) => {
    //const params = useParams<any>();
    const [previousData, setPreviousData] = useState<{ StreamId: number, AVE: number, Count: number }[]>([]);
    const [currentData, setCurrentData] = useState<{ StreamId: number, AVE: number, Count: number }[]>([]);
    const difference = dateTo.diff(dateFrom, 'days');
    const [type, setType] = useState<"COUNT" | "AVE">("COUNT");

    const getPreviousData = useCallback(async () => {
        const data = await api.mentions.getAll(projectId, dateFrom.clone().subtract(difference + 1, 'days'), dateTo.clone().subtract(1, 'day'), streamIds);
        setPreviousData(data);
    }, [projectId, dateFrom, dateTo, streamIds, difference])

    const getCurrentData = useCallback(async () => {
        const data = await api.mentions.getAll(projectId, dateFrom, dateTo, streamIds);
        setCurrentData(data);
    }, [projectId, dateFrom, dateTo, streamIds])

    const getStreamName = (id: number) => {
        return {
            7: "twitter",
            8: "facebook",
            9: "instagram",
            10: "youtube",
            11: "linkedin"
        }[id] || "";
    }

    const getIcon = (previous: number, current: number) => {
        if (previous < current) {
            return <i className="fal fa-chart-line" style={{ color: 'green' }}></i>
        } else if (current < previous) { 
            return <i className="fal fa-chart-line-down" style={{ color: 'red' }}></i>
        } else {
            return <i className="fal fa-equals" style={{ color: 'grey' }}></i>
        }
    }

    useEffect(() => {
        getPreviousData();
        getCurrentData();
    }, [getPreviousData, getCurrentData])
    

    return (
        <div className="date-range-comparison">
            <i className="fal fa-times" onClick={onClose}></i>
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            {difference < 2 
                                ? dateFrom.format("DD MMMM YYYY") 
                                : `${dateFrom.clone().subtract(difference + 1, 'days').format("DD MMM YYYY")} - 
                                ${dateFrom.clone().subtract(1, 'days').format("DD MMM YYYY")}`
                            }
                        </th>
                        <th>
                            {type === "COUNT" ? <FaHashtag onClick={() => setType("AVE")} /> : <FaHryvnia onClick={() => setType("COUNT")} />}
                        </th>
                        <th>
                            {difference < 2
                                ? dateTo.format("DD MMMM YYYY") 
                                : `${dateFrom.format("DD MMM YYYY")} - 
                                ${dateTo.format("DD MMM YYYY")}`
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {streamIds.map((x, i) => {
                        const previousValues = previousData.find(p => p.StreamId === x);
                        const currentValues = currentData.find(c => c.StreamId === x);
                        return (
                            <tr>
                                <td><i className={`fab fa-${getStreamName(x)}`}></i></td>
                                <td>
                                    {type === "COUNT" && <span className="count">{previousValues?.Count || 0}</span>}
                                    {type === "AVE" && <CurrencyFormat value={previousValues?.AVE.toFixed(2) || 0} prefix="R" displayType="text" thousandSeparator={true} />}
                                </td>
                                <td>
                                    {getIcon(type === "COUNT" ? previousValues?.Count || 0 : previousValues?.AVE || 0, type === "COUNT" ? currentValues?.Count || 0 : currentValues?.AVE || 0)}
                                </td>
                                <td>
                                    {type === "COUNT" && <span className="count">{currentValues?.Count || 0}</span>}
                                    {type === "AVE" && <CurrencyFormat value={currentValues?.AVE.toFixed(2) || 0} prefix="R" displayType="text" thousandSeparator={true} />}
                                </td>
                            </tr>
                        )
                    })}
                    <tr>
                        <td></td>
                        <td>
                            {type === "COUNT"
                                ? <span className="count">{previousData.map(x => x.Count).reduce((a, b) => a + b, 0)}</span>
                                : <CurrencyFormat value={previousData.map(x => x.AVE).reduce((a, b) => a + b, 0).toFixed(2) || 0} prefix="R" displayType="text" thousandSeparator={true} />
                            }
                        </td>
                        <td>
                            {type === "COUNT"
                                ? getIcon(previousData.map(x => x.Count).reduce((a, b) => a + b, 0), currentData.map(x => x.Count).reduce((a, b) => a + b, 0))
                                : getIcon(previousData.map(x => x.AVE).reduce((a, b) => a + b, 0), currentData.map(x => x.AVE).reduce((a, b) => a + b, 0))
                            }
                        </td>
                        <td>
                            {type === "COUNT"
                                ? <span className="count">{currentData.map(x => x.Count).reduce((a, b) => a + b, 0)}</span>
                                : <CurrencyFormat value={currentData.map(x => x.AVE).reduce((a, b) => a + b, 0).toFixed(2) || 0} prefix="R" displayType="text" thousandSeparator={true} />
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default React.memo(DateRangeComparison);